import { useState } from 'react';
import type { CSSProperties } from 'react';

export type NgCheckboxProps = {
  value: boolean;
  onValueChanged: (value: boolean) => void | Promise<void>;
  text?: string;
  enabled?: boolean;
  isLoading?: boolean;
};

export function NgCheckbox({
  value,
  onValueChanged,
  text,
  enabled = true,
  isLoading = false,
}: NgCheckboxProps) {
  const [inputId] = useState(() => `el${crypto.randomUUID().replaceAll('-', '')}`);
  const [hintId] = useState(() => `el${crypto.randomUUID().replaceAll('-', '')}`);
  const [isWaiting, setIsWaiting] = useState(false);

  const styleClass: CSSProperties = enabled ? { cursor: 'pointer' } : { pointerEvents: 'none' };
  const cssClass = `d-flex flex-row justify-content-between ps-0${enabled ? '' : ' text-muted'}`;

  const toggleCheckbox = async () => {
    setIsWaiting(true);
    await onValueChanged(!value);
    setIsWaiting(false);
  };

  return (
    <div style={{ minHeight: '36px' }} className="w-100">
      {isLoading || isWaiting ? (
        <div className="d-flex flex-row justify-content-between">
          <span>{text}</span>
          <div className="spinner-border spinner-border-sm" role="status" />
        </div>
      ) : (
        <div style={styleClass} onClick={() => void toggleCheckbox()}>
          <div className={`hx-form-group position-relative form-check ${cssClass}`}>
            <input
              style={styleClass}
              id={inputId}
              type="checkbox"
              className="form-check-input order-1 ms-4"
              aria-describedby={hintId}
              disabled={!enabled}
              checked={value}
              value="True"
              onChange={() => void toggleCheckbox()}
              onClick={(event) => event.stopPropagation()}
            />
            <label className="form-check-label" htmlFor={inputId}>
              <span className="order-0" style={styleClass}>
                {text}
              </span>
            </label>
            <div id={hintId} />
          </div>
        </div>
      )}
    </div>
  );
}
